import apiReducer from 'src/shared/reducers/api_data';

import { FETCH, FETCH_SUCCESS, FETCH_FAILURE } from './actions';

export default apiReducer({
  initActions: [ FETCH ],
  successActions: [ FETCH_SUCCESS ],
  failureActions: [ FETCH_FAILURE ],
});
